import { render, staticRenderFns } from "./UserSummaryPopover.vue?vue&type=template&id=585e6b56&scoped=true"
import script from "./UserSummaryPopover.vue?vue&type=script&lang=js"
export * from "./UserSummaryPopover.vue?vue&type=script&lang=js"
import style0 from "./UserSummaryPopover.vue?vue&type=style&index=0&id=585e6b56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585e6b56",
  null
  
)

export default component.exports